import { NissanCustomStyle } from 'core/skins/NISSAN/custom'
import { theme } from 'core/skins/NISSAN/theme'
import { PropsWithChildren } from 'react'
import { createGlobalStyle, ThemeProvider } from 'styled-components'

const GlobalStyle = createGlobalStyle`
`

export const PortalThemeProvider = ({ children }: PropsWithChildren<any>) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <NissanCustomStyle>{children}</NissanCustomStyle>
    </ThemeProvider>
  )
}
